import { requireSupabase } from "@/lib/supabaseClient";
import { guard } from "@/lib/errors";

// Professional roles that require an application + admin approval.
export const APPLICATION_ROLES = ["agent", "agency", "developer", "manager"];

export const roleApplicationService = {
  // Latest application for a user (any status).
  mine: (userId) => guard("roleApp.mine", async () => {
    if (!userId) return null;
    const s = requireSupabase();
    const { data, error } = await s.from("role_applications")
      .select("*").eq("user_id", userId)
      .order("created_at", { ascending: false }).limit(1).maybeSingle();
    if (error) throw error; return data;
  }),

  submit: (userId, requested_role, message, details = {}) => guard("roleApp.submit", async () => {
    const s = requireSupabase();
    const { data, error } = await s.from("role_applications")
      .insert({ user_id: userId, requested_role, message: message || null, details: details || {}, status: "pending" })
      .select().maybeSingle();
    if (error) throw error; return data;
  }),

  // Admin: list pending (or all) applications with the applicant profile.
  list: (status = "pending") => guard("roleApp.list", async () => {
    const s = requireSupabase();
    let q = s.from("role_applications")
      .select("*, applicant:profiles!role_applications_user_id_fkey(id, full_name, username, email, avatar_url, role)")
      .order("created_at", { ascending: false });
    if (status) q = q.eq("status", status);
    const { data, error } = await q;
    if (error) throw error; return data || [];
  }),

  // Admin: approve → promote the applicant's role + mark approved.
  approve: (application, adminId) => guard("roleApp.approve", async () => {
    const s = requireSupabase();
    await s.from("profiles").update({ role: application.requested_role }).eq("id", application.user_id);
    if (application.requested_role === "agent") {
      await s.from("agents").upsert({ id: application.user_id }, { onConflict: "id" });
    } else if (application.requested_role === "developer") {
      await s.from("developers").upsert({ id: application.user_id, company_name: "My Company" }, { onConflict: "id" });
    }
    const { error } = await s.from("role_applications")
      .update({ status: "approved", reviewed_by: adminId, reviewed_at: new Date().toISOString() })
      .eq("id", application.id);
    if (error) throw error; return true;
  }),

  reject: (id, adminId, note) => guard("roleApp.reject", async () => {
    const s = requireSupabase();
    const { error } = await s.from("role_applications")
      .update({ status: "rejected", admin_note: note || null, reviewed_by: adminId, reviewed_at: new Date().toISOString() })
      .eq("id", id);
    if (error) throw error; return true;
  }),
};
